import { NgModule } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  NgbCollapseModule,
  NgbNavModule,
  NgbDropdownModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

// scroll package
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../pipes/pipes.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatSliderModule } from '@angular/material/slider';

// component
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';

import { NewsCarouselComponent } from './news-carousel/news-carousel.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { RequestNotificationComponent } from './request-notification/request-notification.component';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { DialogCustomComponent } from './dialog-custom/dialog-custom.component';
import { ControlsComponent } from './controls/controls.component';
import { OpenPayPopupComponent } from './open-pay-popup/open-pay-popup.component';
import { LoadPayComponent } from './load-pay/load-pay.component';
import { Controls2ComponentComponent } from './controls2/controls2-component/controls2-component.component';

//
import { LanguageService } from '../services/global/language.service';
import { LocationMapComponent } from './location-map/location-map.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AddAddressComponent } from './add-address/add-address.component';
import { GoogleMap, GoogleMapsModule } from '@angular/google-maps';
import { OrderStartComponent } from './order-start/order-start.component';
import { DeliveryAddressComponent } from './delivery-address/delivery-address.component';
import { LocationOpenMapComponent } from './location-open-map/location-open-map.component';
import { AccordionComponent } from './accordion/accordion.component';
import { CardComponent } from './accordion/card/card.component';
import { BarcodeDialogComponent } from './barcode-dialog/barcode-dialog.component';
import { NgxBarcode6 } from 'ngx-barcode6';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    NewsCarouselComponent,
    BreadcrumbComponent,
    AccordionComponent,
    CardComponent,
    RequestNotificationComponent,
    SidemenuComponent,
    DialogCustomComponent,
    AddAddressComponent,
    ControlsComponent,
    Controls2ComponentComponent,
    OpenPayPopupComponent,
    LoadPayComponent,
    LocationMapComponent,
    // GoogleMap,

    OrderStartComponent,
    DeliveryAddressComponent,
    LocationOpenMapComponent,
    BarcodeDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SlickCarouselModule,
    ScrollToModule.forRoot(),

    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatCardModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatRadioModule,
    MatRippleModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    MatStepperModule,
    NgbCollapseModule,
    NgbNavModule,
    NgbDropdownModule,
    PipesModule,

    GoogleMap,
    GoogleMapsModule,
    NgxMatSelectSearchModule,
    NgxBarcode6,
  ],
  providers: [LanguageService, Location],
  exports: [
    //modules
    FormsModule,
    ReactiveFormsModule,
    MatSliderModule,
    TranslateModule,
    SlickCarouselModule,
    ScrollToModule,
    PipesModule,
    NgxMatSelectSearchModule,

    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatCardModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatRadioModule,
    MatRippleModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    MatStepperModule,

    HeaderComponent,
    FooterComponent,
    NewsCarouselComponent,
    BreadcrumbComponent,
    AccordionComponent,
    CardComponent,
    RequestNotificationComponent,
    SidemenuComponent,
    ControlsComponent,
    Controls2ComponentComponent,

    DialogCustomComponent,
    OpenPayPopupComponent,
    LoadPayComponent,

    LocationMapComponent,
    AddAddressComponent,
    LocationOpenMapComponent,
    OrderStartComponent,
    DeliveryAddressComponent,
    BarcodeDialogComponent
  ],
})
export class SharedModule {}
